import { render, staticRenderFns } from "./NavbarGiftBoxPhone.vue?vue&type=template&id=197a0e3e&scoped=true&"
import script from "./NavbarGiftBoxPhone.vue?vue&type=script&lang=js&"
export * from "./NavbarGiftBoxPhone.vue?vue&type=script&lang=js&"
import style0 from "./NavbarGiftBoxPhone.vue?vue&type=style&index=0&id=197a0e3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197a0e3e",
  null
  
)

export default component.exports